/**
 * 平台檢測：TWA、PWA 環境
 */

export function isTWAEnvironment(): boolean {
  const params = new URLSearchParams(window.location.search);
  const referrer = document.referrer;

  if (params.get('twa_launch') === 'true') return true;
  if (params.get('source') === 'twa') return true;
  if (params.get('source') === 'pwa') return false;
  if (referrer.includes('android-app://')) return true;
  if (localStorage.getItem('runningAsPWA') === 'true') return false;

  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.includes('android');
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone;
  const hasWebView = ua.includes('wv') && ua.includes('version/') && ua.includes('chrome');

  return !!(isAndroid && isStandalone && hasWebView);
}

export function isPWAEnvironment(): boolean {
  const standalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone;
  const params = new URLSearchParams(window.location.search);
  const savedAsPWA = localStorage.getItem('runningAsPWA') === 'true';

  return standalone || params.get('source') === 'pwa' || savedAsPWA;
}
